import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useRef,
} from 'react';

import * as S from './styles';

import { FormControlLabel, Switch } from '@mui/material';
import { handleMaxWidth } from '../../../../../util/newStudent';
import { useTheme } from 'styled-components';
import { myDataServiceNewStudent } from '../../../../../services/newStudent';
import { TextDecrease, TextIncrease } from '@mui/icons-material';
import {
  NewStudentProviderContext,
  INewStudentProvider,
} from '../../../ProviderNewStudent';
import NotificationBell from '../../../NotificationBell/index';

interface Props {
  fontSizeSelected: string;
  setFontSizeSelected: Dispatch<SetStateAction<string>>;
  setThemeSelected: Dispatch<SetStateAction<string>>;
  themeSelected: string;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function Header({
  setFontSizeSelected,
  fontSizeSelected,
  setThemeSelected,
  themeSelected,
  open,
  setOpen,
}: Props) {
  const { setIsLoading } = useContext(
    NewStudentProviderContext,
  ) as INewStudentProvider;
  const userInformation = localStorage.getItem('dataStudent');
  const userData = JSON.parse(String(userInformation));
  const arrayFontSize = ['xSmall', 'small', 'normal', 'large', 'xLarge'];
  const fontCurrent = arrayFontSize.indexOf(userData?.preferences?.fontSize);
  const theme = useTheme();
  const ref = useRef<HTMLDivElement>(null);
  const returnSize = (size: string) => {
    switch (size) {
      case 'xLarge':
        return 'Muito grande';
      case 'large':
        return 'Grande';

      case 'normal':
        return 'Padrão';

      case 'small':
        return 'Pequeno';

      case 'xSmall':
        return 'Muito pequeno';
    }
  };

  const changeLayout = async (data: {
    theme: string;
    isOldLayout?: boolean;
    fontSize?: string;
  }) => {
    try {
      setIsLoading(true);
      const { result } = await myDataServiceNewStudent.updatePreferences({
        theme: data.theme,
        isOldLayout: data.isOldLayout,
        fontSize: data.fontSize,
      });
      if (result) {
        setFontSizeSelected(data.fontSize ?? fontSizeSelected);
        setThemeSelected(data.theme);
        const userInfoTheme = localStorage.getItem('dataStudent');
        const userData = userInfoTheme ? JSON.parse(userInfoTheme) : null;
        if (userData) {
          localStorage.setItem(
            'dataStudent',
            JSON.stringify({
              ...userData,
              preferences: {
                ...userData.preferences,
                theme: data.theme,
                fontSize: data.fontSize,
              },
            }),
          );
        }
      }
    } catch (error) {
      throw new Error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const increaseFont = () => {
    if (fontCurrent < arrayFontSize.length - 1) {
      changeLayout({
        theme: userData.preferences.theme,
        isOldLayout: false,
        fontSize: arrayFontSize[fontCurrent + 1],
      });
    }
  };

  const decreaseFont = () => {
    if (fontCurrent > 0) {
      changeLayout({
        theme: userData.preferences.theme,
        isOldLayout: false,
        fontSize: arrayFontSize[fontCurrent - 1],
      });
    }
  };

  const handleOpenAccessibility = () => {
    return (
      <S.FocusDiv ref={ref}>
        <S.AccessibilityFocus onClick={() => setOpen(!open)}>
          <S.PFocus>Acessibilidade</S.PFocus>
          <img
            src={
              themeSelected === 'contrast'
                ? '/assets/img/accessibility_green.svg'
                : '/assets/img/accessibility_purple.png'
            }
            width="20px"
            height="20px"
          />
        </S.AccessibilityFocus>
        <S.HeaderOption>
          <S.TitleOption>Cores e contrastes</S.TitleOption>
        </S.HeaderOption>
        <S.Option>
          <S.Opt>
            <FormControlLabel
              control={
                <Switch
                  checked={themeSelected === 'contrast'}
                  onChange={(e) => {
                    e.target.checked
                      ? changeLayout({
                          theme: 'contrast',
                          fontSize: fontSizeSelected,
                        })
                      : changeLayout({
                          theme: 'light',
                          fontSize: fontSizeSelected,
                        });
                  }}
                />
              }
              label={<S.OptText>Alto contraste</S.OptText>}
              labelPlacement="end"
            />
          </S.Opt>
          <S.Opt>
            <FormControlLabel
              control={
                <Switch
                  checked={themeSelected === 'gray'}
                  onChange={(e) => {
                    e.target.checked
                      ? changeLayout({
                          theme: 'gray',
                          fontSize: fontSizeSelected,
                        })
                      : changeLayout({
                          theme: 'light',
                          fontSize: fontSizeSelected,
                        });
                  }}
                />
              }
              label={<S.OptText>Tons de cinza</S.OptText>}
              labelPlacement="end"
            />
          </S.Opt>
          <S.Opt>
            <FormControlLabel
              control={
                <Switch
                  checked={themeSelected === 'dark'}
                  onChange={(e) => {
                    e.target.checked
                      ? changeLayout({
                          theme: 'dark',
                          fontSize: fontSizeSelected,
                        })
                      : changeLayout({
                          theme: 'light',
                          fontSize: fontSizeSelected,
                        });
                  }}
                />
              }
              label={<S.OptText>Claro/Escuro</S.OptText>}
              labelPlacement="end"
            />
          </S.Opt>
          <S.HeaderOption>
            <S.TitleOption>Fontes</S.TitleOption>
          </S.HeaderOption>

          <S.FontLayout>
            <S.FontIcon onClick={() => decreaseFont()}>
              <TextDecrease
                sx={{ cursor: fontCurrent > 0 ? 'pointer' : 'default' }}
                fontSize="large"
                color={fontCurrent > 0 ? 'info' : 'disabled'}
              />
            </S.FontIcon>
            <S.OptFontText>{returnSize(theme.fontSizeType)}</S.OptFontText>
            <S.FontIcon onClick={() => increaseFont()}>
              <TextIncrease
                sx={{
                  cursor:
                    fontCurrent < arrayFontSize.length - 1
                      ? 'pointer'
                      : 'default',
                }}
                fontSize="large"
                color={
                  fontCurrent < arrayFontSize.length - 1 ? 'info' : 'disabled'
                }
              />
            </S.FontIcon>
          </S.FontLayout>
        </S.Option>
      </S.FocusDiv>
    );
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  return (
    <S.Container>
      {!handleMaxWidth(theme.size?.large) ? (
        !open ? (
          <S.Accessibility onClick={() => setOpen(!open)}>
            <S.P>Acessibilidade</S.P>
            <img
              src="/assets/img/accessibility_white.png"
              width="20px"
              height="20px"
            />
          </S.Accessibility>
        ) : (
          handleOpenAccessibility()
        )
      ) : !open ? (
        <></>
      ) : (
        <S.AccessibilityMobile>
          {handleOpenAccessibility()}
        </S.AccessibilityMobile>
      )}
      <S.NotificationBellSlot>
        <NotificationBell />
      </S.NotificationBellSlot>
    </S.Container>
  );
}
